/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-10-12 15:08:49
 * @LastEditors: DESKTOP-02E09R4\admin dinglongxin@sunengineering.cn
 * @LastEditTime: 2024-10-23 11:36:36
 * @FilePath: \thatOpenTools\src\components\IfcViewer\ComponentContext.tsx
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */

import React, { useMemo, useState } from "react";

export const pageText = React.createContext<any>(null);

export function PageTextProvider(props: any) {
    const { children } = props || {};
    const [isInit, setIsInit] = useState(false); // 是否初始化
    const [loading, setLoading] = useState(false); // 加载中状态
    const [exploderActive, setExploderActive ] = useState<boolean>(false);
    const [leftActive, setLeftActive] = useState<boolean>(false);  // 左侧菜单展开
    const [rightActive, setRightActive] = useState<boolean>(false); // 右侧菜单展开
    const [leftActiveKey, setLeftActiveKey] = useState<string>('modelList'); // 左侧菜单展开key
    const [rightActiveKey, setRightActiveKey] = useState<string>('propertySet'); // 右侧菜单展开key
    const [cameraType, setCameraType] = useState<string>('Orbit'); // 相机类型
    const [projectionType, setProjectionType] = useState<string>('Perspective'); // 投影类型


    const contextValue = useMemo(() => {
        return {
            isInit,
            setIsInit,
            loading,
            setLoading, 
            exploderActive,
            setExploderActive,
            leftActive, setLeftActive,
            rightActive, setRightActive,
            leftActiveKey, setLeftActiveKey,
            rightActiveKey, setRightActiveKey,
            cameraType, setCameraType,
            projectionType, setProjectionType,
        }
        }, [isInit, loading, exploderActive, leftActive, rightActive,leftActiveKey, rightActiveKey,cameraType, projectionType, ]
    )

    return <pageText.Provider value={contextValue}>{children}</pageText.Provider>;
}